import Request from "./request";
const Service = "/core/service";

export default {
  async getService(query) {
    return Request.get(Service, {
      pageSize: query.pageSize,
      current: query.current
    });
  }
};
